import _ from 'lodash';

class LinksService {
    /*@ngInject*/
    constructor(templateData) {
        this._raw = templateData.linklists;
    }

    getLinks(handle) {
        let match = _.find(this._raw, (l) => {
            return l.handle === handle;
        });

        return _.get(match, 'links', []);
    }

    getMap(handle) {
        return _.transform(this.getLinks(handle), (result, l, index) => {
            result[l.title] = {
                priority: index,
                title: l.title,
                url: l.url,
                object: l.object
            };
        });
    }
}

export default LinksService;